<section class="meal-diet-goal">
  <h2 class="ng-title">{{ title }}</h2>
  <p class="ng-subtitle">
    {{ subtitle }}
  </p>

  <div class="meal-grid">
    <article class="meal-card" *ngFor="let meal of cards; trackBy: trackByMeal">
      <div class="image-box">
        <img [src]="meal.image" [alt]="meal.alt" />
      </div>
      <div class="meal-card-content">
        <h3 class="meal-card-title">{{ meal.title }}</h3>
        <p class="meal-card-description">{{ meal.description }}</p>
      </div>
    </article>
  </div>

  <p class="ng-note">
    {{ note }}
  </p>

  <div class="button-box">
    <app-orange-button [text]="ctaText" (action)="scrollToElement('ng-for-business-form')" size="md" />
  </div>
</section>
